﻿// ------------------------------------------------------------------------------------------------
// -- Class: Template Manager   ------------------------------------------------------------------------
// -- File : templateManager.js ------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------

export { TemplateManager };


/**
 * Class Occurrence
 */
const TemplateManager = function () {

    //Define this
    var myTemplateManager = this;

    // -- begin public variable -------------------------------------------------------------------

    // Screen Size validation object
    var sizeValidation = [];

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private variable ------------------------------------------------------------------
    
    // Map Object
    this.mapCanvas;

    // Template dimensions

    // A4 Vertical
    this.exportA4VOptimalWidth;
    this.exportA4VOptimalHeight;
    this.exportA4VWidth;
    this.exportA4VHeight;
    // A4 Vertical Route
    this.exportA4VRouteOptimalWidth;
    this.exportA4VRouteOptimalHeight;
    this.exportA4VRouteWidth;
    this.exportA4VRouteHeight;
    // A4 Horizontal
    this.exportA4HOptimalWidth;
    this.exportA4HVOptimalHeight;
    this.exportA4HWidth;
    this.exportA4HHeight;
    // A3 Vertical
    this.exportA3VOptimalWidth;
    this.exportA3VOptimalHeight;
    this.exportA3VWidth;
    this.exportA3VHeight;
    // A3 Horizontal
    this.exportA3HOptimalWidth;
    this.exportA3HOptimalHeight;
    this.exportA3HWidth;
    this.exportA3HHeight;

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Prepare Export
     * Updates screen for export view
     * @param object mapCanvas - Map object
     * @param string templateSize - Template format, one from array ['A4v', 'A4VRoute', 'A4h', 'A3v', 'A3h']
    */
    this.prepareExport = function (mapCanvas, templateSize) {

        var exportSize = myTemplateManager.getExportSize(templateSize);
        var exportWidth = 0;
        var exportHeight = 0;


        if (templateSize.height_img && templateSize.width_img) {

            exportWidth = templateSize.width_img
            exportHeight = templateSize.height_img;

        } else {
            exportWidth = exportSize.width;
            exportHeight = exportSize.height;
        }

        // Get export format dimensions for given template
        
         

        // Updates screen highlighted export area
        myTemplateManager.prepareHighlight(mapCanvas, exportWidth, exportHeight);

        // Displays highlighted area
        myTemplateManager.toggleHighlight();

        // Hide modal
        $('#id-modal-map-export').toggle('ol-hidden');

        // Toggle Menu
        if (!$('#menubar-export-bottom-pl').is(':visible'))
            $('#menubar-export-bottom-pl').toggle('ol-hidden');
    }

    /**
     * Set Sizes
     * Updates object's document sizes and validates them agains screen size
     * @returns {A4v: bool, A4vRoute: bool, A4h: bool, A3v: bool, A3h: bool} validSizes - Boolean flag to signal whether screen allows for each template format
    */
    this.setSizes = function () {

        var validSizes = {
            "A4v": true,
            "A4vRoute": true,
            "A4h": true,
            "A3v": true,
            "A3h": true
        };

        myTemplateManager.mapCanvas = $('canvas.ol-unselectable');

        // A4

        // A4 Vertical
        myTemplateManager.exportA4VOptimalWidth = 629; // 669
        myTemplateManager.exportA4VOptimalHeight = 620;
        myTemplateManager.exportA4VWidth = myTemplateManager.mapCanvas.width() < myTemplateManager.exportA4VOptimalWidth ? myTemplateManager.mapCanvas.width() : myTemplateManager.exportA4VOptimalWidth;
        myTemplateManager.exportA4VHeight = myTemplateManager.mapCanvas.height() < myTemplateManager.exportA4VOptimalHeight ? myTemplateManager.mapCanvas.height() : myTemplateManager.exportA4VOptimalHeight;
         
        // A4 Vertical Route
        myTemplateManager.exportA4VRouteOptimalWidth = 629; // 669
        myTemplateManager.exportA4VRouteOptimalHeight = 620;
        myTemplateManager.exportA4VRouteWidth = myTemplateManager.mapCanvas.width() < myTemplateManager.exportA4VRouteOptimalWidth ? myTemplateManager.mapCanvas.width() : myTemplateManager.exportA4VRouteOptimalWidth;
        myTemplateManager.exportA4VRouteHeight = myTemplateManager.mapCanvas.height() < myTemplateManager.exportA4VRouteOptimalHeight ? myTemplateManager.mapCanvas.height() : myTemplateManager.exportA4VRouteOptimalHeight;

        // A4 Horizontal
        myTemplateManager.exportA4HOptimalWidth = 1023;
        myTemplateManager.exportA4HOptimalHeight = 440;
        myTemplateManager.exportA4HWidth = myTemplateManager.mapCanvas.width() < myTemplateManager.exportA4HOptimalWidth ? myTemplateManager.mapCanvas.width() : myTemplateManager.exportA4HOptimalWidth;
        myTemplateManager.exportA4HHeight = myTemplateManager.mapCanvas.height() < myTemplateManager.exportA4HOptimalHeight ? myTemplateManager.mapCanvas.height() : myTemplateManager.exportA4HOptimalHeight;

        // A3

        // A3 Vertical 
        myTemplateManager.exportA3VOptimalWidth = 1003;
        myTemplateManager.exportA3VOptimalHeight = 1250;
        myTemplateManager.exportA3VWidth = myTemplateManager.mapCanvas.width() < myTemplateManager.exportA3VOptimalWidth ? myTemplateManager.mapCanvas.width() : myTemplateManager.exportA3VOptimalWidth;
        myTemplateManager.exportA3VHeight = myTemplateManager.mapCanvas.height() < myTemplateManager.exportA3VOptimalHeight ? myTemplateManager.mapCanvas.height() : myTemplateManager.exportA3VOptimalHeight;

        // A3 Horizontal
        myTemplateManager.exportA3HOptimalWidth = 1477;
        myTemplateManager.exportA3HOptimalHeight = 744;
        myTemplateManager.exportA3HWidth = myTemplateManager.mapCanvas.width() < myTemplateManager.exportA3HOptimalWidth ? myTemplateManager.mapCanvas.width() : myTemplateManager.exportA3HOptimalWidth;
        myTemplateManager.exportA3HHeight = myTemplateManager.mapCanvas.height() < myTemplateManager.exportA3HOptimalHeight ? myTemplateManager.mapCanvas.height() : myTemplateManager.exportA3HOptimalHeight;

        // Validations

        if (myTemplateManager.exportA4VOptimalWidth > myTemplateManager.mapCanvas.width()) {
            validSizes["A4v"] = false;
        }

        if (myTemplateManager.exportA4VRouteOptimalWidth > myTemplateManager.mapCanvas.width()) {
            validSizes["A4vRoute"] = false;
        }

        if (myTemplateManager.exportA4HOptimalWidth > myTemplateManager.mapCanvas.width()) {
            validSizes["A4h"] = false;
        }

        if (myTemplateManager.exportA3VOptimalWidth > myTemplateManager.mapCanvas.width()) {
            validSizes["A3v"] = false;
        }

        if (myTemplateManager.exportA3HOptimalWidth > myTemplateManager.mapCanvas.width()) {
            validSizes["A3h"] = false;
        }

        myTemplateManager.sizeValidation = validSizes;

    }
    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Get Export Size 
     * Returns document dimensions for a given document format
     * @param string templateSize - One from array ['A4v', 'A4h', 'A3v', 'A3h']
     * @returns {width, height} exportSize
    */
    this.getExportSize = function (templateSize) {

        var exportSize = { width: myTemplateManager.exportA4VWidth, height: myTemplateManager.exportA4VHeight };

        switch (templateSize) {

            case "A4v":
                exportSize.width = myTemplateManager.exportA4VWidth;
                exportSize.height = myTemplateManager.exportA4VHeight;
                break;
            case "A4vRoute":
                exportSize.width = myTemplateManager.exportA4VRouteWidth;
                exportSize.height = myTemplateManager.exportA4VRouteHeight;
                break;
            case "A4h":
                exportSize.width = myTemplateManager.exportA4HWidth;
                exportSize.height = myTemplateManager.exportA4HHeight;
                break;
            case "A3v":
                exportSize.width = myTemplateManager.exportA3VWidth;
                exportSize.height = myTemplateManager.exportA3VHeight;
                break;
            case "A3h":
                exportSize.width = myTemplateManager.exportA3HWidth;
                exportSize.height = myTemplateManager.exportA3HHeight;
                break;
            default:
                break;
        }

        return exportSize;

    }

    /**
     * Toggle Highlight
     * Displays Highlight area on map
     * @param bool toggleType - False to hide, true to show, when not defined it toggles visibility
    */
    this.toggleHighlight = function (toggleType) {

        if (typeof toggleType == "undefined") {
            $('.map-highlight-left,.map-highlight-right,.map-highlight-top,.map-highlight-bottom').toggleClass('hidden');
        } else {
            $('.map-highlight-left,.map-highlight-right,.map-highlight-top,.map-highlight-bottom').removeClass('hidden');
            if (!toggleType) {
                $('.map-highlight-left,.map-highlight-right,.map-highlight-top,.map-highlight-bottom').addClass('hidden');
            } 
        }

    }

    /**
     * Prepare Highlight
     * Updates screen highlight area dimensions
     * @param object mapCanvas - Map object to update
     * @param int exportWidth - Pixel width to highlight on map center
     * @param int exportHeight - Pixel height to highlight on map center
    */
    this.prepareHighlight = function (mapCanvas, exportWidth, exportHeight) {

        // Remove highlight elements present
        $('.map-highlight-left, .map-highlight-right, .map-highlight-top, .map-highlight-bottom').remove();

        // Left and Right
        var mapImageWidth = exportWidth;
        var highlightWidth = Math.ceil((mapCanvas.width() - mapImageWidth) / 2);
        var highlightLeft = document.createElement('div');
        highlightLeft.className = "map-highlight-left hidden";
        var highlightRight = document.createElement('div');
        highlightRight.className = "map-highlight-right hidden";
        highlightLeft.style.width = highlightWidth + "px";
        highlightRight.style.width = highlightWidth + "px";
        mapCanvas.append(highlightLeft);
        mapCanvas.append(highlightRight);

        // Top and Bottom
        var mapImageHeight = exportHeight;
        var highlightHeight = Math.ceil((mapCanvas.height() - mapImageHeight) / 2);
        var highlightTop = document.createElement('div');
        highlightTop.className = "map-highlight-top hidden";
        var highlightBottom = document.createElement('div');
        highlightBottom.className = "map-highlight-bottom hidden";
        highlightTop.style.height = highlightHeight + "px";
        highlightBottom.style.height = highlightHeight + "px";
        highlightTop.style.left = highlightWidth + "px";
        highlightBottom.style.left = highlightWidth + "px";
        highlightTop.style.width = exportWidth + "px";
        highlightBottom.style.width = exportWidth + "px";
        mapCanvas.append(highlightTop);
        mapCanvas.append(highlightBottom);

    }

    /**
     * Prepare Highlight
     * Updates screen highlight area dimensions
     * @param object mapCanvas - Map object to update
     * @param int exportWidth - Pixel width to highlight on map center
     * @param int exportHeight - Pixel height to highlight on map center
    */
    this.getHighlightExtent = function (mapCanvas, mapExtent) {

        var newMapExtent = [];

        var xOffset = $('.map-highlight-left').width() / mapCanvas.width();
        var yOffset = $('.map-highlight-top').height() / mapCanvas.height();
        var xOffsetEnd = $('.map-highlight-right').width() / mapCanvas.width();
        var yOffsetEnd = $('.map-highlight-bottom').height() / mapCanvas.height();

        var mapWidth = 0;
        if (mapExtent[2] > 0 && mapExtent[0] > 0) {
            mapWidth = mapExtent[2] - mapExtent[0];
        } else if (mapExtent[2] < 0 && mapExtent[0] < 0){
            mapWidth = (mapExtent[0] * -1) - (mapExtent[2] * -1);
        } else {
            mapWidth = mapExtent[2] + mapExtent[0];
        }
        var mapHeight = 0;
        if (mapExtent[3] > 0 && mapExtent[1] > 0) {
            mapHeight = mapExtent[3] - mapExtent[1];
        } else if (mapExtent[3] < 0 && mapExtent[1] < 0) {
            mapHeight = (mapExtent[1] * -1) - (mapExtent[3] * -1);
        } else {
            mapHeight = mapExtent[3] + mapExtent[1];
        }

        var mapXCutLeft = mapWidth * xOffset;
        var mapXCutRight = mapWidth * xOffsetEnd;
        var mapYCutBottom = mapHeight * yOffsetEnd;
        var mapYCutTop = mapHeight * yOffset;

        newMapExtent[0] = (mapExtent[0] + mapXCutLeft).toFixed(2);
        newMapExtent[1] = (mapExtent[1] + mapYCutBottom).toFixed(2);
        newMapExtent[2] = (mapExtent[2] - mapXCutRight).toFixed(2);
        newMapExtent[3] = (mapExtent[3] - mapYCutTop).toFixed(2);

        return newMapExtent;

    }


    // -- end private method ----------------------------------------------------------------------

  
};